/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S3_IntroInputs */

const tr_hakkimizda_s3_intro = /** @type {(inputs: Hakkimizda_S3_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altyapımızı büyük ölçekli SaaS sağlayıcılarının kullandığı en güncel araçlar üzerine kurduk:`)
};

const en_hakkimizda_s3_intro = /** @type {(inputs: Hakkimizda_S3_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We built our infrastructure on the most up-to-date tools used by large-scale SaaS providers:`)
};

const de_hakkimizda_s3_intro = /** @type {(inputs: Hakkimizda_S3_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Infrastruktur haben wir auf den aktuellsten Werkzeugen aufgebaut, die auch großskalige SaaS-Anbieter einsetzen:`)
};

const ru_hakkimizda_s3_intro = /** @type {(inputs: Hakkimizda_S3_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нашу инфраструктуру мы построили на самых современных инструментах, которые используют крупные SaaS-провайдеры:`)
};

/**
* | output |
* | --- |
* | "We built our infrastructure on the most up-to-date tools used by large-scale SaaS providers:" |
*
* @param {Hakkimizda_S3_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s3_intro = /** @type {((inputs?: Hakkimizda_S3_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S3_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s3_intro(inputs)
	if (locale === "de") return de_hakkimizda_s3_intro(inputs)
	if (locale === "ru") return ru_hakkimizda_s3_intro(inputs)
	return tr_hakkimizda_s3_intro(inputs)
});